/**
 * 🧨 The progress epoch — bumped when everyone's progress is wiped.
 *
 * Lives in shared/ (v3.96) because BOTH sides must agree on it: the app
 * wipes storage and discards stale cloud pulls against it, and the
 * leaderboard submit routes refuse claims from sessions that predate it.
 * That second half was missing from the v3.79 wipe: a friend of Javi's
 * still had a pre-wipe session open in a tab, and its leaderboard
 * submission sailed through — the boards were reset by hand, but the
 * write path never asked which era a claim came from.
 */
export const PROGRESS_EPOCH = 1
